import React from 'react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import { withStyles } from '@material-ui/core/styles';
import { blue } from '@material-ui/core/colors';
import Grid from '@material-ui/core/Grid';
import './loginform.css';

class SignupForm extends React.Component {
  state = {
    username: '',
    password: ''
  };

  handle_change = e => {
    const name = e.target.name;
    const value = e.target.value;
    this.setState(prevstate => {
      const newState = { ...prevstate };
      newState[name] = value;
      return newState;
    });
  };

  render() {
    return (
      <form onSubmit={e => this.props.handle_signup(e, this.state)}>
        <div>

          <Grid container justify="center" alignItems="center">
            
            <Grid item xs={3.5} />

            <Grid item xs={5} className="form-content">
              <div className="email-header">
                Email {" "}
                <span className="email-header-2">(or username)</span>
              </div>
              <input 
                autofocus="autofocus"
                placeholder="e.g., example@example.com"
                type="text"
                name="username"
                value={this.state.username}
                onChange={this.handle_change}
                className="email-input" />

              <div className="email-header">
                Password {" "}
              </div>
              <input
                type="password"
                name="password"
                value={this.state.password}
                onChange={this.handle_change}
                className="email-input" />
              
              <div className="button-submit">
                <input type="submit"/>
              </div>
            </Grid>

            <Grid item xs={3.5}></Grid>
          </Grid>
        </div>
      </form>
    );
  }
}

export default SignupForm;

SignupForm.propTypes = {
  handle_signup: PropTypes.func.isRequired
};


// WEBPACK FOOTER //
// ./src/components/SignupForm.js